<script setup lang="ts">
  import { onMounted, onUnmounted } from "vue";
  import { storeToRefs } from "pinia";
  import { Banner } from "@/components/episto-ui/banner";
  import { useMCampaignGenerationStore } from "@stores/mCampaignGeneration";
  import { useMCampaignStore } from "@stores/mCampaign";
  import { captureEvent } from "@/lib/analytics";

  const mCampaignGenerationStore = useMCampaignGenerationStore();
  const { isStale } = storeToRefs(mCampaignGenerationStore);
  const { currentMCampaign } = storeToRefs(useMCampaignStore());

  const reload = () => {
    captureEvent("m_campaign_stale_tab_reloaded", { m_campaign_token: currentMCampaign.value?.token });
    window.location.reload();
  };

  onMounted(() => mCampaignGenerationStore.start());
  onUnmounted(() => mCampaignGenerationStore.stop());
</script>

<template>
  <Banner
    v-if="isStale"
    message="This campaign was modified elsewhere since this page was loaded. Saving from this tab overwrites those changes."
    class="mb-4">
    <template #action>
      <button
        type="button"
        class="ml-auto shrink-0 font-medium underline underline-offset-2"
        @click="reload">
        Reload
      </button>
    </template>
  </Banner>
</template>
